import { cn } from '@/utils/cn';

const barStyle = (delay: number, isVertical: boolean) =>
  ({
    animationDelay: `${delay}ms`,
    '--logo-pulse-scale-start': isVertical ? '1 0.3' : '0.3 1',
    '--logo-pulse-scale-end': isVertical ? '1 1' : '1 1',
  }) as React.CSSProperties;

type LogoLoaderProps = {
  className?: string;
  orientation?: 'horizontal' | 'vertical';
};

export function LogoLoader({
  className,
  orientation = 'horizontal',
}: LogoLoaderProps) {
  const isVertical = orientation === 'vertical';

  return (
    <div
      className={cn(
        'flex gap-1.5',
        isVertical ? 'items-end' : 'flex-col items-start',
        className,
      )}
    >
      <div
        className={cn(
          'animate-logo-pulse bg-primary rounded-xs',
          isVertical ? 'h-4 w-2 origin-bottom' : 'h-2 w-4 origin-left',
        )}
        style={barStyle(0, isVertical)}
      />
      <div
        className={cn(
          'animate-logo-pulse bg-primary rounded-xs',
          isVertical ? 'h-8 w-2 origin-bottom' : 'h-2 w-8 origin-left',
        )}
        style={barStyle(150, isVertical)}
      />
      <div
        className={cn(
          'animate-logo-pulse bg-primary rounded-xs',
          isVertical ? 'h-12 w-2 origin-bottom' : 'h-2 w-12 origin-left',
        )}
        style={barStyle(300, isVertical)}
      />
    </div>
  );
}
